export const ResourcesArticleLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M22.5012 10.0626L24.9375 12.4978C25.0363 12.5966 25.1146 12.714 25.168 12.8432C25.2214 12.9723 25.2488 13.1107 25.2486 13.2505C25.2484 13.3902 25.2206 13.5286 25.1669 13.6576C25.1131 13.7866 25.0345 13.9037 24.9354 14.0023L23.4043 15.5259L19.4709 11.5915L20.9988 10.0626C21.1981 9.86336 21.4683 9.75146 21.75 9.75146C22.0317 9.75146 22.3019 9.86336 22.5012 10.0626ZM17.9675 13.0949L10.5938 20.4676V24.3479H14.5314L21.8966 17.0241L17.9675 13.0949Z"
        fill="#05050D"
      />
    </svg>
  );
};
